/* eslint-disable import/no-extraneous-dependencies */
// icons
import quotesIcon from '@iconify/icons-carbon/quotes';
// @mui
import { Typography, Stack, Avatar, alpha } from '@mui/material';
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

interface Testimonial {
  name: string;
  company: string;
  description: string;
  image?: string;
  white?: boolean;
  companyLogo: string;
}

type Props = {
  testimonial: Testimonial;
  isSelected?: boolean;
};

export function TestimonialsContentItem({ testimonial, isSelected }: Props) {
  const { description } = testimonial;

  return (
    <Stack alignItems="center" sx={{ bgcolor: alpha('#0E2A40', 0.59), mb: 1, borderRadius: 2 }}>
      <Iconify
        icon={quotesIcon}
        sx={{ width: 48, height: 48, opacity: 0.48, color: 'primary.main' }}
      />
      <Typography
        sx={{
          mt: 2,
          mb: 2,
          lineHeight: 1.75,
          minHeight: 230,
          fontSize: { xs: 20, md: 18 },
          fontFamily: (theme) => theme.typography.h1.fontFamily,
        }}
      >
        {description}
      </Typography>
    </Stack>
  );
}

// ----------------------------------------------------------------------

export function TestimonialsThumbnailItem({ testimonial, isSelected }: Props) {
  const { companyLogo } = testimonial;

  return (
    <Stack
      sx={{
        width: 96,
        height: 96,
        alignItems: 'center',
        justifyContent: 'center',
        ml: 20,
      }}
    >
      <Avatar
        src={companyLogo}
        sx={{
          width: 48,
          height: 48,
          opacity: 0.48,
          cursor: 'pointer',
          transition: (theme) => theme.transitions.create('all'),
          ...(isSelected && {
            opacity: 1,
            transform: 'scale(2)',
          }),
          objectFit: testimonial.image ? 'cover' : 'contain',
          borderRadius: '100px 100px 20px 100px ',
          border: (theme) => `5px solid ${theme.palette.secondary.darker}`,
          backgroundColor: testimonial.white ? 'secondary.darker' : 'black',
        }}
      />
    </Stack>
  );
}
